export const EASY = 'easy';
export const MEDIUM = 'medium';
export const HARD = 'hard';
export const difficultyDisplayNames = {
  easy: 'Warmup',
  medium: 'Medium',
  hard: 'Challenging',
};
